/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FinOpsConsolidatedReportScheduleRequest extends models.NextGenReportScheduleRequest {
    constructor() {
        super();
        this.setDiscriminator("FinOpsConsolidatedReportScheduleRequest");
    }

    getFixupPrototypeFunction() { return FinOpsConsolidatedReportScheduleRequest.fixupPrototype; }

    static newInstance(model: Partial<FinOpsConsolidatedReportScheduleRequest>): FinOpsConsolidatedReportScheduleRequest {
        let obj = Object.assign(new FinOpsConsolidatedReportScheduleRequest(), model);
        FinOpsConsolidatedReportScheduleRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FinOpsConsolidatedReportScheduleRequest>): FinOpsConsolidatedReportScheduleRequest {
        if (!model) return null;
        return FinOpsConsolidatedReportScheduleRequest.newInstance(<FinOpsConsolidatedReportScheduleRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FinOpsConsolidatedReportScheduleRequest) {
        if (!obj) return;

        models.FinOpsConsolidatedReportScheduleRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FinOpsConsolidatedReportScheduleRequest): boolean {
        if (models.NextGenReportScheduleRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, FinOpsConsolidatedReportScheduleRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.configuration) {
            models.ConfigurationForNextGenReportBase.fixupPrototype(this.configuration);
        }
    }

    /**
     * Report configuration to generate report
     */
    configuration: models.ConfigurationForNextGenReportBase;

}
